import { getEmptyValue as r } from "../constants/index.mjs";
const a = (l = [], o) => ({
  options: l.length > 0 ? l : [r(o)],
  disabled: (e) => (e == null ? void 0 : e.disabled) ?? !1
});
export {
  a as getVirtualizedData
};
